import { render, staticRenderFns } from "./StickyCta.vue?vue&type=template&id=2a5d9e49"
import script from "./StickyCta.vue?vue&type=script&lang=js"
export * from "./StickyCta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports